import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { IconArrowLeft, IconGps, IconCurrentLocation } from '@tabler/icons';

import {
  Container,
  Button,
  Wrapper,
  BackButton,
  ExternalButton,
} from './styles';

interface ModalProps {
  label?: string;
  onClose: () => void;
  definePosition?: boolean;
  onGetLocal?: () => void;
  isOpen: boolean;
  lat?: any;
  long?: any;
  [x: string]: any;
}

export default function Modal({
  children,
  label,
  isOpen,
  onClose,
  definePosition,
  onGetLocal,
  lat,
  long,
}: ModalProps) {
  const history = useHistory();

  // hide scrollbar when is open
  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      if (isOpen) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  }, [isOpen]);

  // prevent navigating back when back button is pressed
  useEffect(() => {
    const unblock = history.block((location, action): any => {
      if (action === 'POP' && isOpen) {
        onClose();

        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [isOpen, history]);

  if (!isOpen) {
    return null;
  }

  return (
    <Container style={{ zIndex: isOpen ? 1001 : -10 }}>
      {!definePosition && (
        <BackButton onClick={onClose}>
          <IconArrowLeft size={25} />
        </BackButton>
      )}

      {lat && long && (
        <ExternalButton
          href={`https://www.google.com.br/maps/dir//${lat},${long}`}
        >
          <IconGps size={25} style={{ marginRight: 10 }} />
          Ver rotas
        </ExternalButton>
      )}

      {onGetLocal && (
        <BackButton onClick={onGetLocal}>
          <IconCurrentLocation size={25} />
        </BackButton>
      )}

      {children}

      {definePosition && (
        <Wrapper>
          <Button onClick={onClose}>{label}</Button>
        </Wrapper>
      )}
    </Container>
  );
}
